module.exports = __webpack_public_path__ + "img/logo.7d12aa2e.svg";